var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_392528_album_gallery_image_images_photo_icon",
    "data-name": "392528_album_gallery_image_images_photo_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.743,
    height: 16.298,
    viewBox: "0 0 20.743 16.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M22,21.3H2.741A.741.741,0,0,1,2,20.557V8.7a.741.741,0,0,1,1.482,0V19.816h17.78V6.482H2.741A.741.741,0,1,1,2.741,5H22a.741.741,0,0,1,.741.741V20.557A.74.74,0,0,1,22,21.3Z",
    transform: "translate(-2 -5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(14.872 3.649)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(0.374 -0.5)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(2.222 5.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M5.741,20.408a.741.741,0,0,1-.524-1.265l5.927-5.927a.74.74,0,0,1,1.048,0l2.222,2.222a.741.741,0,1,1-1.048,1.048l-1.7-1.7-5.4,5.4A.739.739,0,0,1,5.741,20.408Z",
    transform: "translate(-5 -13)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(10.371 8.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M22.667,21.445a.739.739,0,0,1-.524-.217l-2.44-2.44-2.44,2.44a.741.741,0,1,1-1.048-1.048l2.963-2.963a.74.74,0,0,1,1.048,0l2.963,2.963a.741.741,0,0,1-.524,1.265Z",
    transform: "translate(-16 -17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageImages);
export default __webpack_public_path__ + "static/media/image_images.015b77dc6229a98e29b8534629aef568.svg";
export { ForwardRef as ReactComponent };